<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Accounts</div>
    <div class="divider"></div>
    <div class="search-box input-box">
      <svg-icon src="assets/svg/magnifier.svg"></svg-icon>

      <mat-form-field>
        <input
          matInput
          (keyup)="applyFilter()"
          matInput
          type="text"
          [(ngModel)]="searchValue"
        />
      </mat-form-field>
    </div>
    <div class="divider"></div>
    <div class="filter">
      <button mat-button class="icon-btn" (click)="toggleFilterDialog()">
        <svg-icon src="assets/svg/filter.svg" svgClass="grey"></svg-icon>
      </button>
    </div>
  </div>
  <div class="header-center"></div>
  <div class="header-right">
    <button
      *ngIf="showNewAccount"
      mat-button
      color="lightGreen"
      (click)="createNewAccount()"
    >
      Create New Account
    </button>
  </div>
</div>

<div class="accounts-list">
  <div class="container accounts-container">
    <div class="container-header no-bottom-border">
      <div class="text">Existing Accounts</div>
      <div class="options">
        <button
          *ngIf="showNewAccount"
          mat-icon-button
          [matMenuTriggerFor]="accountsMenu"
        >
          <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
        </button>
        <mat-menu
          class="mat-menu-elaphant vertical-menu"
          #accountsMenu="matMenu"
        >
          <button
            *ngIf="showNewAccount"
            class="icon-btn-w-text"
            mat-menu-item
            (click)="createNewAccount()"
          >
            <svg-icon src="assets/svg/plus-circle-white.svg"></svg-icon>
            <span>Create New Account</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="container-content">
      <table #accountsTable mat-table [dataSource]="accountDataSource" matSort matSortActive="name" matSortDirection="asc" [matSortDisableClear]="false">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Account Name
          </th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let element">
            {{ element.id }}
          </td>
        </ng-container>

        <ng-container matColumnDef="created_by_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Created By</th>
          <td mat-cell *matCellDef="let element">
            {{ element.created_by_name ? element.created_by_name : "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Creation Date
          </th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.created_at">
              {{ formatDate(element.created_at) }}
            </span>
            <span *ngIf="!element.created_at"> - </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="active">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Active</th>
          <td mat-cell *matCellDef="let element">
            {{ element.active ? "Yes" : "No" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="options">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="options-cell">
            <button
              *ngIf="showEdit"
              mat-button
              (click)="edit(element)"
              class="icon-btn"
            >
              <svg-icon
                src="assets/svg/pencil.svg"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <div *ngIf="!showEdit" class="empty-btn-space"></div>
            <button
              *ngIf="!isCurrentAccount(element) && showDelete"
              mat-button
              (click)="delete(element)"
              class="icon-btn"
            >
              <svg-icon
                src="assets/svg/trashcan.svg"
                [svgStyle]="{
                  'width.px': '15.25',
                  'height.px': '16.204'
                }"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <div
              *ngIf="!(!isCurrentAccount(element) && showDelete)"
              class="empty-btn-space"
            ></div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
